import { styled } from "@mui/system";
import { InputLabel, inputLabelClasses } from "@mui/material";

const InputLabelWizard = styled(InputLabel)(({ theme }) => ({
	color: theme.palette.text.primary,
	fontWeight: 600,
	[`& .${inputLabelClasses.asterisk}`]: {
		color: theme.palette.error.main,
	},
}));

export default InputLabelWizard;
